export var EAnalyticsConstant = /*#__PURE__*/function (EAnalyticsConstant) {
  EAnalyticsConstant["Error"] = "\u0427\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A";
  EAnalyticsConstant["TimeoutError"] = "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435";
  return EAnalyticsConstant;
}({});
export var EAnalyticsActionConstant = /*#__PURE__*/function (EAnalyticsActionConstant) {
  EAnalyticsActionConstant["View"] = "view";
  EAnalyticsActionConstant["Click"] = "click";
  EAnalyticsActionConstant["FillIn"] = "fill_in";
  return EAnalyticsActionConstant;
}({});
export var EAnalyticsItemTypeConstant = /*#__PURE__*/function (EAnalyticsItemTypeConstant) {
  EAnalyticsItemTypeConstant["Page"] = "page";
  EAnalyticsItemTypeConstant["Icon"] = "icon";
  EAnalyticsItemTypeConstant["Button"] = "button";
  EAnalyticsItemTypeConstant["Field"] = "field";
  EAnalyticsItemTypeConstant["Element"] = "element";
  EAnalyticsItemTypeConstant["Message"] = "message";
  EAnalyticsItemTypeConstant["QR"] = "QR-\u043A\u043E\u0434 \u0421\u0411\u041F";
  EAnalyticsItemTypeConstant["Popup"] = "popup";
  EAnalyticsItemTypeConstant["Toggle"] = "toggle";
  EAnalyticsItemTypeConstant["Block"] = "block";
  EAnalyticsItemTypeConstant["RadioButton"] = "radiobutton";
  EAnalyticsItemTypeConstant["Widget"] = "widget";
  return EAnalyticsItemTypeConstant;
}({});